import React from 'react';
// import logo from '../images/logo/logo.png';

const Footer = () => (
  <React.Fragment>
    <div className="footer-pattern-top">
      <div className="footer-pattern-slide" />
    </div>
    <div className="footer">
      {/* cta start */}
      <div className="container">
        <div className="cta cta-v1">
          <div className="row">
            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
              <div className="cta-content">
                <h1 className="cta-title">Ready to get started ?</h1>
                <p className="cta-text">Speak to a our specialist at (+91-9741115000)</p>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
              <div className="cta-btn">
                <a href="#contact" className="btn btn-brand btn-rounded btn-lg">Request a Free Demo</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* cta end */}
      <div className="container">
        <div className="row">
          <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12">
            <div className="footer-widget">
              <h3 className="footer-widget-title">
              Protect Your Cloud Today
              </h3>
              <p>
              Your move to the Cloud is inevitable. A damaging breach
in the Cloud is not.
                <br />
                {' '}
Contact paladion to learn how.
              </p>
            </div>
          </div>
          <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6">
            <div className="footer-widget">
              <h3 className="footer-widget-title">
              Useful Links
              </h3>
              <ul className="list-unstyled angle-right">
                <li><a href="#home">Home</a></li>
                <li><a href="#services">Services</a></li>
                <li><a href="#about">About us</a></li>
                <li><a href="#contact">Contact us</a></li>
              </ul>
            </div>
          </div>
          {/* /.footer-widget */}
          <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 text-md-right">
            {/* footer-widget */}
            <div className="footer-widget">
              <h3 className="footer-widget-title">
              Contact Address
              </h3>
              <p className="mb-0">
              Shilpa Vidya, 49 1st Main, 3rd Phase JP Nagar,

                <br />
                {' '}
                Bangalore- 560078
                {' '}
                <br />
              </p>
              <p className="mb-0">+91-9741115000</p>
            </div>
          </div>
          {/* /.footer-widget */}
          {/* footer-widget */}

        </div>
      </div>
    </div>
    {/* tiny-footer-section */}
    <div className="tiny-footer">
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 float-right text-right">
            <ul className="list-unstyled">
              <li className="mr-3">Copyright © 2019 Paladion.</li>
              <li><a href="https://www.paladion.net/">All Rights Reserved</a></li>
            </ul>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 ">
            <ul className="list-unstyled">
              <li className="float-md-right"><a href="https://www.facebook.com/paladionetworks"><i className="fab fa-facebook-square" /></a></li>
              <li className="float-md-right"><a href="https://twitter.com/paladionn"><i className="fab fa-twitter-square" /></a></li>
              <li className="float-md-right"><a href="https://www.linkedin.com/company/paladion-networks"><i className="fab fa-linkedin" /></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>
);
export default Footer;
